export default {"src":"/_next/static/media/zip_line.8a8b726e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};